
const clearLocalStorage =  () => {
    localStorage.removeItem("secondsPlayed");
    localStorage.removeItem("percentagePlayed");
    localStorage.removeItem("user");
    localStorage.removeItem("lessons");
    localStorage.removeItem("videoProgress");
}

export default clearLocalStorage;